export default {
    label_task:{
        en:"Market Requirement",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Market Requirement",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Market Requirement",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Market Requirement",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_market_size:{
        en:"Market Size",
        bn:"কর্মচারী আইডি"
    },
    label_sowing_periods:{
        en:"Sowing Period",
        bn:"কর্মচারী আইডি"
    },
    label_competitor_varieties_ids:{
        en:"Competitors Variety",
        bn:"কর্মচারী আইডি"
    },
    label_reason_sales:{
        en:"Reason for the Sales",
        bn:"কর্মচারী আইডি"
    },
    label_total_type_entered:{
        en:"# of types data",
        bn:"কর্মচারী আইডি"
    },

}